import { render, staticRenderFns } from "./TicketDetailCardAssignees.vue?vue&type=template&id=3ba5b3b2"
import script from "./TicketDetailCardAssignees.vue?vue&type=script&lang=ts"
export * from "./TicketDetailCardAssignees.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports